module.exports = __webpack_public_path__ + "8a5356e9/img/placeholder.888fcd0b.svg";